import WidgetModule from "@eisinc/Overrides/Widgets/Header/AutocompleteProducts";

export * from "@eisinc/Overrides/Widgets/Header/AutocompleteProducts";

export default WidgetModule;
